import { hrBaseApi } from "app/services/HrBaseApi";

export const HrApprovalApi = hrBaseApi.injectEndpoints({
  endpoints: (builder) => ({

    /* ================= HR APPROVAL SYSTEM ================= */

    createHRApprovalAPI: builder.mutation({
      query: (payload) => ({
        url: "/Felix/HRApprovalsystem/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["HRApproval"],
    }),

   /* ================= PURCHASE REQUEST WORKFLOW ================= */

    getPurchaseRequestWorkflowAPI: builder.query({
      query: ({ requestId }) => ({
        url: "/Felix/Purchaserequestworkflow/",
        params: {
          Request_Id: requestId,
        },
      }),
      providesTags: ["HRApproval"],
    }),

  }),
});

export const {
  useCreateHRApprovalAPIMutation,
    useGetPurchaseRequestWorkflowAPIQuery,

} = HrApprovalApi;